// src/components/charts/DonutChart.jsx
import React from 'react';
import { AgCharts } from 'ag-charts-react';

/**
 * Componente DonutChart con ag-Charts
 * @param {Object} props
 * @param {Array} props.data - Datos del gráfico [{ label: 'X', value: 100 }, ...]
 * @param {String} props.angleKey - Key para valores (default: 'value')
 * @param {String} props.labelKey - Key para etiquetas (default: 'label')
 * @param {String} props.title - Título del gráfico
 * @param {Number} props.height - Altura del gráfico (default: 400)
 * @param {Number} props.innerRadiusRatio - Ratio del agujero interior (0-1, default: 0.7)
 */
const DonutChart = ({
  data = [],
  angleKey = 'value',
  labelKey = 'label',
  title = '',
  height = 400,
  innerRadiusRatio = 0.7,
}) => {
  const options = {
    data,
    title: title ? { text: title } : undefined,
    series: [
      {
        type: 'donut',
        angleKey,
        labelKey,
        innerRadiusRatio,
        tooltip: {
          renderer: ({ datum, angleKey }) => ({
            content: `${datum[labelKey]}: ${datum[angleKey].toLocaleString('es-ES')}`,
          }),
        },
      },
    ],
    legend: {
      position: 'right',
    },
  };

  return (
    <div style={{ height }}>
      <AgCharts options={options} />
    </div>
  );
};

export default DonutChart;